import { NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { LayoutDashboard, ArrowDownToLine, ArrowUpFromLine, KeyRound, ShieldCheck, BookOpen, Vault } from "lucide-react";
import { ZeroFeeBadge } from "./StatusBadge";

const NAV = [
  ["/", "Painel", LayoutDashboard, "nav-dashboard-link"],
  ["/recebimentos", "Recebimentos", ArrowDownToLine, "nav-deposits-link"],
  ["/saques", "Saques e pagamentos", ArrowUpFromLine, "nav-payouts-link"],
  ["/api", "API e webhooks", KeyRound, "nav-apikeys-link"],
  ["/seguranca", "Segurança", ShieldCheck, "nav-security-link"],
  ["/docs", "Documentação", BookOpen, "nav-docs-link"],
];

export default function Layout({ me }) {
  return (
    <div className="min-h-screen lg:flex">
      <aside className="sidebar">
        <div className="flex items-center gap-2 px-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500 text-[#04110c]"><Vault size={18} /></div>
          <span className="font-heading text-lg font-bold tracking-tight">CofrePay</span>
        </div>
        <nav className="mt-8 flex gap-1 overflow-x-auto lg:flex-col">
          {NAV.map(([to, label, Icon, tid]) => (
            <NavLink key={to} to={to} end={to === "/"} data-testid={tid}
              className={({ isActive }) => `nav-item ${isActive ? "nav-item-active" : ""}`}>
              <Icon size={17} /> <span className="whitespace-nowrap">{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto hidden rounded-xl border border-emerald-500/20 bg-emerald-500/5 p-4 lg:block">
          <p className="text-xs font-semibold text-emerald-400">2FA protegido</p>
          <p className="mt-1 break-all text-xs text-slate-400" data-testid="sidebar-admin-email">{me.email}</p>
        </div>
      </aside>
      <main className="min-w-0 flex-1">
        <header className="topbar">
          <ZeroFeeBadge />
          <div className="flex items-center gap-3">
            <span className="hidden text-xs text-slate-500 sm:inline">Sessão 2FA expira em 30 min</span>
            <UserButton />
          </div>
        </header>
        <div className="px-4 pb-16 pt-6 sm:px-8 lg:px-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
